var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartBase',{attrs:{"title":"Daily Orders (Last 30 Days)","loading":_vm.loading}},[_c('BarChart',{staticClass:"chart-thirty-day-new-vs-returning line-chart",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }